import { useEffect, useState } from "react";
import { Col, Container, Modal, Pagination, Row, Table } from "react-bootstrap";
import { AdminInstance } from "../utils/adminClass";

export const AdminCheckOutQuestions = () => {
  const [venueType, setVenueType] = useState<"dispensary" | "smokeshop">("dispensary");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [questions, setQuestions] = useState<any[]>([]);
  const [editingQuestion, setEditingQuestion] = useState<any>(null);
  const [newQuestion, setNewQuestion] = useState<any>(null);

  useEffect(() => {
    fetchQuestions();
  }, [venueType]);

  const fetchQuestions = async () => {
    try {
      setIsLoading(true);
      const res = await AdminInstance.getCheckOutQuestions(venueType);
      setQuestions(res);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleAddQuestion = async (question: any) => {
    try {
      setIsLoading(true);
      await AdminInstance.addCheckOutQuestion(question);
      fetchQuestions();
      setNewQuestion(null);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleUpdateQuestion = async (question: any) => {
    try {
      setIsLoading(true);
      await AdminInstance.updateCheckOutQuestion(question);
      fetchQuestions();
      setEditingQuestion(null);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleDeleteQuestion = async (question: any) => {
    try {
      setIsLoading(true);
      await AdminInstance.deleteCheckOutQuestion(question.id);
      fetchQuestions();
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const onChangeNewQuestion = (field: string, value: any) => {
    console.log("new question", newQuestion);
    setNewQuestion((prev: any) => ({ ...prev, [field]: value }));
  };

  const onChangeEditQuestion = (field: string, value: any) => {
    console.log("edit question", editingQuestion);
    setEditingQuestion((prev: any) => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <Container className="py-4">
        <Row>
          <Col>
            <h3>Check Out Questions</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="d-flex justify-content-between">
              <div>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setNewQuestion({
                      topic: "",
                      title: "",
                      lowText: "",
                      highText: "",
                    });
                  }}
                >
                  Add New Question
                </button>
              </div>
              <div>
                <select className="form-select" value={venueType} onChange={(e) => setVenueType(e.target.value as any)}>
                  <option value="dispensary">Dispensary</option>
                  <option value="smokeshop">Smoke Shop</option>
                </select>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Topic</th>
                  <th>Title</th>
                  <th>Low</th>
                  <th>High</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((q, i) => (
                  <tr key={i}>
                    <td>{q.topic}</td>
                    <td>{q.title}</td>
                    <td>{q.lowText}</td>
                    <td>{q.highText}</td>
                    <td>
                      <button className="btn btn-primary btn-sm" onClick={() => setEditingQuestion(q)}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item>{1}</Pagination.Item>
              <Pagination.Item>{2}</Pagination.Item>
              <Pagination.Item>{3}</Pagination.Item>
              <Pagination.Next />
            </Pagination>
          </Col>
        </Row>
      </Container>

      {/* Modal to edit/add questions */}
      <Modal
        show={!!editingQuestion || !!newQuestion}
        onHide={() => {
          setEditingQuestion(null);
          setNewQuestion(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{editingQuestion ? "Edit Question" : "Add New Question"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            {/* venue type */}
            <div className="mb-3">
              <label className="form-label">Venue Type</label>
              <select
                className="form-select"
                value={editingQuestion ? editingQuestion.venueType : newQuestion ? newQuestion.venueType : ""}
                onChange={(e) => {
                  editingQuestion
                    ? onChangeEditQuestion("venueType", e.target.value)
                    : onChangeNewQuestion("venueType", e.target.value);
                }}
              >
                <option value=""></option>
                <option value="dispensary">Dispensary</option>
                <option value="smokeshop">Smoke Shop</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Topic</label>
              <select
                className="form-select"
                value={editingQuestion ? editingQuestion.topic : newQuestion ? newQuestion.topic : ""}
                onChange={(e) => {
                  editingQuestion
                    ? onChangeEditQuestion("topic", e.target.value)
                    : onChangeNewQuestion("topic", e.target.value);
                }}
              >
                <option value=""></option>
                <option value="service">Service</option>
                <option value="products_pricing">Products & Pricing</option>
                <option value="venue">Venue</option>
                <option value="general">General</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={editingQuestion?.title || newQuestion?.title || ""}
                onChange={(e) => {
                  editingQuestion
                    ? onChangeEditQuestion("title", e.target.value)
                    : onChangeNewQuestion("title", e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Low</label>
              <input
                type="text"
                className="form-control"
                value={editingQuestion?.lowText || newQuestion?.lowText || ""}
                onChange={(e) => {
                  editingQuestion
                    ? onChangeEditQuestion("lowText", e.target.value)
                    : onChangeNewQuestion("lowText", e.target.value);
                }}
              />{" "}
            </div>
            <div className="mb-3">
              <label className="form-label">High</label>
              <input
                type="text"
                className="form-control"
                value={editingQuestion?.highText || newQuestion?.highText || ""}
                onChange={(e) => {
                  editingQuestion
                    ? onChangeEditQuestion("highText", e.target.value)
                    : onChangeNewQuestion("highText", e.target.value);
                }}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              editingQuestion ? handleUpdateQuestion(editingQuestion) : handleAddQuestion(newQuestion);
            }}
            disabled={
              (editingQuestion && !editingQuestion.topic) ||
              (editingQuestion && !editingQuestion.title) ||
              (editingQuestion && !editingQuestion.lowText) ||
              (editingQuestion && !editingQuestion.highText) ||
              (editingQuestion && !editingQuestion.venueType) ||
              (newQuestion && !newQuestion.topic) ||
              (newQuestion && !newQuestion.title) ||
              (newQuestion && !newQuestion.lowText) ||
              (newQuestion && !newQuestion.highText) ||
              (newQuestion && !newQuestion.venueType)
            }
            className="btn btn-primary"
          >
            Save
          </button>
          {/* delete button with confirm after if isEditiing */}
          {editingQuestion && (
            <button
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this question?")) {
                  handleDeleteQuestion(editingQuestion);
                  setEditingQuestion(null);
                  fetchQuestions();
                }
              }}
              className="btn btn-danger"
            >
              Delete
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
